import { render, staticRenderFns } from "./VideoInfoSubSection.vue?vue&type=template&id=57e98ed0&scoped=true&"
import script from "./VideoInfoSubSection.vue?vue&type=script&lang=js&"
export * from "./VideoInfoSubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e98ed0",
  null
  
)

export default component.exports